export var SET_WISHLIST_ITEMS = 'SET_WISHLIST_ITEMS';
export var ADD_WISHLIST_ITEM = 'ADD_WISHLIST_ITEM';
export var DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM';